export default __webpack_public_path__ + "static/Axiforma-Book-057e3decce8b00d20f709a7fbad71cc7.woff2";